import React, { Component } from 'react'
import GridPost from './gridpost'
import RecentPost from './recentpost'
import { Carousel, Row, Col, Icon, Card, Avatar, Button, List, Input, Pagination, notification } from 'antd';
import post from '../../pages/blog/post';
const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: 'Notification',
    description: message,
  });
};


class OurBlog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // posts: [1, 2, 3, 4, 5, 6]
      currentPage: 1,
      searchInput: '',
      searchResults: [],
      showSearch: false,
      searchLoading: false,
      showCatPosts: false,
      showCatPostsSlug: 'allposts',
      catPosts: [],
      shoowCatPostsLoading: false,
      sortedPosts: []
    }
  }

  searchPosts = (e) => {
    e.preventDefault()
    const { posts } = this.props
    const { searchInput } = this.state
    this.setState({
      showSearch: true,
      showCatPosts: false,
      showCatPostsSlug: 'allposts'
    })
    this.setState({
      searchLoading: true
    })
    setTimeout(() => {
      this.setState({
        searchLoading: false
      })
    }, 700);
    if (searchInput.trim().length) {
      let results = posts.filter(post => post.content.toLowerCase().includes(searchInput.trim().toLowerCase()) || post.title.toLowerCase().includes(searchInput.trim().toLowerCase()))
      this.setState({
        searchResults: results
      })
    } else {
      this.setState({
        searchResults: [],
        showSearch: false,
        showCatPosts: false,
      })
      openNotificationWithIcon('warning', 'You can not make an empty search')
    }
  }

  onPagiChange = page => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.setState({
      currentPage: page
    });
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  loadCatPosts = (e, slug) => {
    e.preventDefault()
    if (slug === 'allposts') {
      this.setState({
        showCatPosts: false,
        showCatPostsSlug: slug,
        showSearch: false,
        catPosts: [],
        shoowCatPostsLoading: false,
        searchInput: ''
      })
    } else {
      this.setState({
        showCatPosts: true,
        showCatPostsSlug: slug,
        showSearch: false,
        catPosts: [],
        shoowCatPostsLoading: true,
        searchInput: ''
      })
      this.props.getCatPosts(slug)
    }
  }

  componentWillReceiveProps(nextProps) {
    const { catPosts, posts } = nextProps
    this.setState({
      catPosts,
      shoowCatPostsLoading: false
    })
    if(posts.length > 0) {
      const sortedPosts = posts.sort((a, b) => new Date(b.created) - new Date(a.created))
      this.setState({
        sortedPosts
      })
    }
  }


  render() {
    const { posts, postcats, fetchPostsSuccess } = this.props
    const { currentPage, searchInput, searchLoading, showSearch, searchResults, showCatPosts, showCatPostsSlug, catPosts, shoowCatPostsLoading, sortedPosts } = this.state
    let start = (currentPage - 1) * 5
    let end = (5 * currentPage)
    let realEnd = end > posts.length ? posts.length : end
    return (
      fetchPostsSuccess && posts.length ?

        <div className="our-blog blog-innner-page">
          <div className="container">
            <div className="mobile-search">
              <form action="#" className="sidebar-search">
                <input type="text" placeholder="Search" name="searchInput" onChange={(e) => this.handleChange(e)} value={searchInput} />
                <button className="tran3s" onClick={(e) => this.searchPosts(e)}><i className="flaticon-search"></i></button>
              </form>
            </div>
            <div className="row">
              {
                !showSearch && !showCatPosts ? <div className="col-md-8 col-xs-12">
                  <div className="row">
                    {
                      posts.slice(start, realEnd).map((post) => (
                        <GridPost key={post.id} detail={post} />
                      ))
                    }
                  </div>
                  <Pagination defaultCurrent={currentPage} total={posts.length} onChange={this.onPagiChange} defaultPageSize={5} />
                </div> : null
              }
              {
                showSearch ? <div className="col-md-8 col-xs-12">
                  {
                    searchLoading ? <div className="loading-holder">
                      <Icon type="loading" style={{ fontSize: 60 }} spin />
                    </div> :
                      <div>
                        {
                          searchResults.length ? <div>
                            <h4 className="x-result-title">Search Results for <i>{searchInput}</i></h4>
                            <div className="row">
                              {
                                searchResults.map((post) => (
                                  <GridPost key={post.id} detail={post} />
                                ))
                              }
                            </div>
                          </div> : <h4 className="x-result-title">No results found for <i>{searchInput}</i></h4>
                        }
                      </div>
                  }
                </div> : null
              }
              {
                showCatPosts ?
                  shoowCatPostsLoading ? <div className="col-md-8 col-xs-12"> <div className="loading-holder">
                    <Icon type="loading" style={{ fontSize: 60 }} spin />
                  </div> </div> : <div className="col-md-8 col-xs-12">
                      {
                        catPosts.length === 0 ? <h4 className="x-result-title">There are no posts under <i>{showCatPostsSlug}</i></h4> : <h4 className="x-result-title">Posts under <i>{showCatPostsSlug}</i></h4>
                      }
                      <div className="row">
                        {
                          catPosts.map((post) => (
                            <GridPost key={post.id} detail={post} />
                          ))
                        }
                      </div>
                    </div> : null
              }
              <div className="col-md-4 col-sm-12 col-xs-12 theme-sidebar">
                <form action="#" className="sidebar-search desktop-search">
                  <input type="text" placeholder="Search" name="searchInput" onChange={(e) => this.handleChange(e)} value={searchInput} />
                  <button className="tran3s" onClick={(e) => this.searchPosts(e)}><i className="flaticon-search"></i></button>
                </form>
                <div className="sidebar-keyword">
                  <h4>Categories</h4>
                  <ul className="clearfix">
                    <li><a href="#" className={`tran3s ${'allposts' === showCatPostsSlug ? 'active' : null}`} onClick={(e) => this.loadCatPosts(e, 'allposts')}>All posts</a></li>
                    {
                      postcats.map((postcat) => (
                        <li key={postcat.id}><a href="#" className={`tran3s ${postcat.slug === showCatPostsSlug ? 'active' : null}`} onClick={(e) => this.loadCatPosts(e, postcat.slug)}>{postcat.name}</a></li>
                      ))
                    }
                  </ul>
                </div>
                <div className="sidebar-recent-news">
                  <h4>Recent News</h4>
                  <ul>
                    {
                      sortedPosts.slice(0, 4).map((rpost) => (
                        <RecentPost key={rpost.id} detail={rpost} />
                      ))
                    }
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> :
        <div style={{ padding: '10em 1em 20em', display: "flex", alignItems: "center", justifyContent: 'center', flex: 1, textAlign: "center", fontSize: 18, fontWeight: 700 }}>
          Blog posts are not available yet. Please check back later
      </div>
    )
  }
}

export default OurBlog
